import { graphql } from 'react-relay';

export const saveSnapshot = graphql`
  mutation snapshotSaveMutation($type: String!, $refundId: String!, $snapshotData: String!) {
    createApplyRefundCertificate(type: $type, refundId: $refundId, snapshotData: $snapshotData) {
      result
      message
    }
  }
`;

export const getSnapshot = graphql`
  query snapshotGetQuery($type: String!, $snapshotCode: String!) {
    getApplyRefundCertificate(type: $type, snapshotCode: $snapshotCode) {
      result
      snapshotData
      message
    }
  }
`;
